





import {Vue, Component} from 'vue-property-decorator';
import API from '@/Api';
@Component
export default class InTime extends Vue {
    public inTime: any = [];
    public today: any = [];
    public mounted() {
        API.Instance
        .get('/api/attendance/in-time')
        .then((response) => {
            this.inTime = response.data.response;
            this.today = response.data.today;
        })
    }
}
